import React from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import useGettext from '../../../util/GettextFactory';
import { useApplyForMeCopy } from '../hooks/useApplyForMeCopy';

/**
 * Report Issue Page Layout
 * Provides context for the report issue flow and renders nested routes
 */
const ReportIssuePage: React.FC = () => {
    const gt = useGettext();
    const copy = useApplyForMeCopy();
    return (
        <>
            <Helmet>
                <title>{copy.reportIssueTitle}</title>
                <meta
                    name="description"
                    content={gt.gettext('Report an issue with your job application')}
                />
            </Helmet>
            <Outlet />
        </>
    );
};

export default ReportIssuePage;
